import type { Locale } from '@app/shared/types/locale'

export function formatNumber(value: number, locale: Locale): string {
  return new Intl.NumberFormat(locale).format(value)
}

export function formatPercentage(value: number, locale: Locale): string {
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

// Compact notation: 75,000 → "75K", 37,500,000 → "37.5M". Locale-aware —
// suffixes follow the locale's CLDR conventions. Used for y-axis labels in
// the drawer where horizontal space is tight.
export function formatCompact(value: number, locale: Locale): string {
  return new Intl.NumberFormat(locale, {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(value)
}

export function formatCompactPercentage(value: number, locale: Locale): string {
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(value)
}
